
"use client";

import { useEffect, useState } from "react";

interface ScrollToTopProps {
  className?: string;
  showAtPixels?: number;
}

export default function ScrollToTop({ className = "", showAtPixels = 300 }: ScrollToTopProps) {
  const [isVisible, setIsVisible] = useState(false);


  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > showAtPixels) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, [showAtPixels]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`z-50 flex h-12 w-12 w-full items-center justify-center bg-primary text-white shadow-lg transition-opacity duration-300 hover:bg-primary/90 ${
        isVisible ? "opacity-100" : "pointer-events-none opacity-0"
      } ${className}`}
      aria-label="Scroll to top"
    >
      <span className="inter text-white">Scroll to Top</span>
    </button>
  );
}
